import { schema } from 'normalizr';

import { compact } from '../../../../../helpers/compact';
import {
  FrequenciesEnum,
  Page,
  PageType,
} from '../../../../../types/page/page';
import { toLink, toNumber, toText } from '../../../fields';
import { toFrequency } from '../../../mapping';
import { documentEntity } from './document';

const processPage: schema.StrategyFunction<Page> = (doc) =>
  compact({
    meta: compact({
      title: toText(doc.data?.meta_title) || toText(doc.data?.title),
      description: doc.data?.meta_description,
      image: doc.data?.meta_image,
      indexed: doc.data?.meta_indexing !== 'non',
    }),
    seoText: toText(doc.data?.seo_text),
    sitemapPriority: toNumber(doc.data?.seo_sitemap_priority, {
      min: 0,
      max: 1,
      defaultValue: 0.8,
    }),
    sitemapChangeFrequency:
      toFrequency(doc.data?.seo_sitemap_change_frequency) ||
      FrequenciesEnum.WEEKLY,
    breadcrumbParent: toLink(doc.data?.seo_breadcrumb_parent),
    breadcrumb: toText(
      doc.data?.breadcrumb || doc.data?.title || doc.data?.meta_title
    ),
    title: toText(doc.data?.title),
  });

/**
 * Function to transform a prismic deprecated page to a document.
 */
export const pageEntity = <T extends Page = Page>(
  type: PageType,
  { processStrategy, ...rest }: schema.EntityOptions<T>
): schema.Entity<T> =>
  documentEntity<T>(type, {
    processStrategy: (entity, parent, key) => ({
      ...processStrategy(entity, parent, key),
      ...processPage(entity, parent, key),
    }),
    ...rest,
  });
